export default () => window.dashboardVenueList ? window.dashboardVenueList : []
